module.exports = __webpack_public_path__ + "img/icon-group.de2ad949.svg";